// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ZAk-L","title":"Info_title__3Hu1V","selects":"Info_selects__5jobw","requiredAsterisk":"Info_requiredAsterisk__1zwMr"};